const n = async (e) => new Promise((t) => setTimeout(t, e));
export {
  n as delay
};
//# sourceMappingURL=delay.js.map
